export default __webpack_public_path__ + "static/media/architecture.9b6302e0.jpg";